/**
 * @file JS - Controller - MultiMapPageController.js
 * @author : Adam Lemire
 * @since 2020/07/29
 * @version 1.0
 * @summary Dernières modifications : 2023/02/23
 */

import { MultiMapPageFormat } from '../../helpers/Constants.js'; // eslint-disable-line no-unused-vars
import { GisSection } from '../../helpers/Selectors.js';
import MultiMapPage from '../../classes/Page/MultiMapPage.js'; // eslint-disable-line no-unused-vars
import SingleMapPage from '../../classes/Page/SingleMapPage.js'; // eslint-disable-line no-unused-vars
import { Evenements } from '../../events/Evenements.js';

require('jquery-ui/ui/core');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui/themes/base/slider.css');

export default class MultiMapPageController {
  constructor () {
    /** @type { MultiMapPage } */
    this._multiMapPage = null;
    /** @type { SingleMapPage [] } */
    this._singleMapPages = [];
  }

  get multiMapPage () {
    return this._multiMapPage;
  }

  set multiMapPage (multiMapPage) {
    this._multiMapPage = multiMapPage;
    this._écouterHTMLSelectChoixCarteChangé();
    this._actualiserHTMLOptionsChoixCarteSelectionnées();
    this._updateSelectedFormatToExistingValue();
    this._transferSingleMapPagesInLayout();
    this._actualiserHTMLSelectOptionsChoixCarte();
    this._resetSwipeSliderValue();
    this._multiMapPage.refreshView();
  }

  get singleMapPages () { return this._singleMapPages; }

  /** @param { SingleMapPage [] } singleMapPages */
  set singleMapPages (singleMapPages) {
    const _this = this;
    this._singleMapPages = singleMapPages;

    this._singleMapPages.forEach(function (singleMapPage) {
      singleMapPage.registerTitleChangedListener(function (title) {
        _this._actualiserHTMLSelectOptionsChoixCarte();
      });
    });
  }

  activer () {
    this._écouterHTMLSelectChoixCarteChangé();
    this._écouterSélecteurFormat();
  }

  /** @param { SingleMapPage } singleMapPage */
  addSingleMapPage (singleMapPage) {
    const _this = this;
    singleMapPage.registerTitleChangedListener(function (title) {
      _this._actualiserHTMLSelectOptionsChoixCarte();
    });
    this._singleMapPages.push(singleMapPage);
    this._actualiserHTMLSelectOptionsChoixCarte();
  }

  /** @param { SingleMapPage } singleMapPage */
  removeSingleMapPage (singleMapPage) {
    const filteredSingleMapPages = this._singleMapPages.filter(e => e !== singleMapPage);
    this._singleMapPages = filteredSingleMapPages;
    this._actualiserHTMLSelectOptionsChoixCarte();
  }

  registerNewMultiMapListeners () {
    this._écouterModificationLargeurCoucheSuperposée();
    this._registerOpacitySliderListener();
    this._registerSwipeSliderListener();
  }

  /*
   * MAP PAGE LAYOUT
   */

  /**
   * @param { MultiMapPageFormat } format
   * @param { number } mapPageId
   * @returns { string }
   */
  static créerHtml (format = MultiMapPageFormat.HORIZONTAL, mapPageId) {
    const layout = '<div id="multimap-' + mapPageId + '__layout" class="multimap__layout multimap__layout--' + format.label + '">' +
    '<div id="multimap-' + mapPageId + '__map1" class="multimap__map multimap-' + mapPageId + '__map multimap__map1" data-map-position=1><div class="multimap__map-label" data-text="leftMenu.multiMap.map1Label"></div></div>' +
    '<div id="multimap-' + mapPageId + '__map2" class="multimap__map multimap-' + mapPageId + '__map multimap__map2" data-map-position=2><div class="multimap__map-label" data-text="leftMenu.multiMap.map2Label"></div></div>' +
    '<div id="multimap-' + mapPageId + '__map3" class="multimap__map multimap-' + mapPageId + '__map multimap__map3" data-map-position=3><div class="multimap__map-label" data-text="leftMenu.multiMap.map3Label"></div></div>' +
    '<div id="multimap-' + mapPageId + '__map4" class="multimap__map multimap-' + mapPageId + '__map multimap__map4" data-map-position=4><div class="multimap__map-label" data-text="leftMenu.multiMap.map4Label"></div></div>' +
    '<div id="multimap-' + mapPageId + '__map5" class="multimap__map multimap-' + mapPageId + '__map multimap__map5" data-map-position=5>' +
    '<div id="multimap-' + mapPageId + '__opacity-slider" class="multimap__opacity-slider"><div id="multimap-' + mapPageId + '__opacity-slider-label" class="multimap__opacity-slider-label" data-text="map.opacity"></div><div id="multimap-' + mapPageId + '__opacity-slider-jq" class="multimap__opacity-slider-jq multimap-' + mapPageId + '__opacity-slider-jq"><div id="multimap-' + mapPageId + '__opacity-slider-handle" class="ui-slider-handle"></div></div></div>' +
    '<div id="multimap-' + mapPageId + '__swipe-slider" class="multimap__swipe-slider"><div id="multimap-' + mapPageId + '__swipe-slider-jq" class="multimap__swipe-slider-jq multimap-' + mapPageId + '__swipe-slider-jq"><div id="multimap-' + mapPageId + '__swipe-slider-handle" class="multimap__swipe-slider-handle ui-slider-handle"><div class="multimap__swipe-slider-handle-left"><span class="tooltip" data-text="leftMenu.multiMap.map6Label"></span></div><div class="multimap__swipe-slider-handle-middle"></div><div class="multimap__swipe-slider-handle-right"><span class="tooltip" data-text="leftMenu.multiMap.map5Label"></span></div></div></div></div>' +
    '<div id="multimap-' + mapPageId + '__overlay" class="multimap__overlay multimap-' + mapPageId + '__overlay">' +
    '<div id="multimap-' + mapPageId + '__map6" class="multimap__map multimap-' + mapPageId + '__map multimap__map6" data-map-position=6>' +
    '</div></div></div></div>';

    const nouvelleSectionCarteHtml = '<div id="map__section-' + mapPageId + '" class="map__section multi-map__section map__section-' +
      mapPageId + '"><pre class="map__info map__info-' + mapPageId + '"></pre>' + layout + '</div>';

    $(GisSection.MAP).append(nouvelleSectionCarteHtml);
    Evenements.texteAjoute.notify();
  }

  _transferSingleMapPagesInLayout () {
    const _this = this;
    const mapDivs = '.multimap-' + this._multiMapPage.id + '__map';
    $(mapDivs).each(function () {
      const mapPosition = $(this).data('map-position');
      const mapPage = _this._multiMapPage.getMapAtPosition(mapPosition);

      mapPage && _this._multiMapPage.setMapAtPosition(mapPage, mapPosition);
    });
  }

  _écouterModificationLargeurCoucheSuperposée () {
    console.log('TESTER ICI');

    const baseMapId = '#multimap-' + this._multiMapPage.id + '__map5';
    const overlayMapId = '#multimap-' + this._multiMapPage.id + '__map6';

    this._multiMapPage.registerViewChangedListener(function () {
      $(overlayMapId).width($(baseMapId).width());
    });
  }

  /*
   * Overlay - Opacity
   */

  _registerOpacitySliderListener () {
    const _this = this;
    const sliderId = '#multimap-' + this._multiMapPage.id + '__opacity-slider-jq';

    $(sliderId).slider({
      slide: function (event, ui) {
        _this._changeOverlayMapOpacity(ui.value);
      },
      value: 100
    });
  }

  /** @param { number } opacity */
  _changeOverlayMapOpacity (opacity) {
    const mapSectionId = '#multimap-' + this._multiMapPage.id + '__map6';
    const opacityDecimal = opacity / 100;
    $(mapSectionId).css({ opacity: opacityDecimal });
  }

  /*
   * Overlay - Swipe
   */

  _registerSwipeSliderListener () {
    const _this = this;
    const sliderId = '#multimap-' + this._multiMapPage.id + '__swipe-slider-jq';

    $(sliderId).slider({
      slide: function (event, ui) {
        _this._changeOverlayMapWidth(ui.value);
      },
      step: 0.2,
      value: 50
    });
  }

  /** @param { number } widthPercent - defaut = 50 */
  _resetSwipeSliderValue (widthPercent = 50) {
    const sliderId = '#multimap-' + this._multiMapPage.id + '__swipe-slider-jq';
    let sliderVal = widthPercent;

    if ($(sliderId).slider('instance')) {
      sliderVal = $(sliderId).slider('value');
    }
    this._changeOverlayMapWidth(sliderVal);
  }

  /**
   * @param { number } width - en %, defaut = 100
   */
  _changeOverlayMapWidth (width = 100) {
    const ovelayMap = '#multimap-' + this._multiMapPage.id + '__overlay';
    const widthString = width + '%';
    $(ovelayMap).css({ width: widthString });
  }

  /*
   * MENU GAUCHE - MultiMap details
   */
  updateSelectedOptions () {
    $('#multimap-formats__select').prop('selectedIndex', 0);
    this._actualiserHTMLSelectOptionsChoixCarte();
  }

  /*
   * MENU GAUCHE - MultiMap details - Format affichage
   */

  _écouterSélecteurFormat () {
    const _this = this;
    $('#multimap-formats__select').off('change').on('change', function () {
      if (_this._multiMapPage) {
        const selectedOption = '#' + $(this).attr('id') + ' option:selected';
        const layoutId = '#multimap-' + _this._multiMapPage.id + '__layout';
        const mapSelector1et2 = '.multimap__select-singlemappage-1, .multimap__select-singlemappage-2';
        const mapSelector1a4 = '.multimap__select-singlemappage-1, .multimap__select-singlemappage-2, .multimap__select-singlemappage-3, .multimap__select-singlemappage-4';
        const mapSelector3a6 = '.multimap__select-singlemappage-3, .multimap__select-singlemappage-4, .multimap__select-singlemappage-5, .multimap__select-singlemappage-6';
        const mapSelector5et6 = '.multimap__select-singlemappage-5, .multimap__select-singlemappage-6';

        if ($(selectedOption).hasClass('format--horizontal')) {
          $(mapSelector1et2).show();
          $(mapSelector3a6).hide();
          _this._changerClasseFormatAffichage(layoutId, 'horizontal');
          _this._multiMapPage.format = MultiMapPageFormat.HORIZONTAL;
          _this._multiMapPage.refreshView();
        } else if ($(selectedOption).hasClass('format--vertical')) {
          $(mapSelector1et2).show();
          $(mapSelector3a6).hide();
          _this._changerClasseFormatAffichage(layoutId, 'vertical');
          _this._multiMapPage.format = MultiMapPageFormat.VERTICAL;
          _this._multiMapPage.refreshView();
        } else if ($(selectedOption).hasClass('format--grid')) {
          $(mapSelector1a4).show();
          $(mapSelector5et6).hide();
          _this._changerClasseFormatAffichage(layoutId, 'grid');
          _this._multiMapPage.format = MultiMapPageFormat.GRID;
          _this._multiMapPage.refreshView();
        } else if ($(selectedOption).hasClass('format--overlay')) {
          $(mapSelector1a4).hide();
          $(mapSelector5et6).show();
          _this._changerClasseFormatAffichage(layoutId, 'overlay');
          _this._multiMapPage.format = MultiMapPageFormat.OVERLAY;
          _this._multiMapPage.refreshView();
          $('.multimap__map6').width($('.multimap__map5').width());
        } else {
          console.log('Erreur dans le format de la multimap');
        }
        _this._actualiserHTMLOptionsChoixCarteSelectionnées();
      }
    });
    $('#multimap-formats__select').change();
  }

  /**
   * @param { string } layoutId - avec le #
   * @param { string } layoutFormat - horizontal, vertical, grid ou overlay
   */
  _changerClasseFormatAffichage (layoutId, layoutFormat) {
    const layoutClassName = 'multimap__layout--' + layoutFormat;
    $(layoutId)
      .removeClass('multimap__layout--horizontal multimap__layout--vertical multimap__layout--grid multimap__layout--overlay')
      .addClass(layoutClassName);
  }

  _updateSelectedFormatToExistingValue () {
    const selectedIndex = this._multiMapPage.format.selectIndex;
    $('#multimap-formats__select').prop('selectedIndex', selectedIndex);
  }

  /*
   * MENU GAUCHE - MultiMap details - Choix des cartes
   */

  _actualiserHTMLSelectOptionsChoixCarte () {
    console.log('_actualiserHTMLSelectOptionsChoixCarte');
    const options = this._créerHTMLOptionsChoixCarte();
    $('.select-singlemappage').empty().append(options);
    Evenements.texteAjoute.notify();
    this._multiMapPage && this._actualiserHTMLOptionsChoixCarteSelectionnées();
    this._écouterHTMLSelectChoixCarteChangé();
  }

  _actualiserHTMLOptionsChoixCarteSelectionnées () {
    const _this = this;
    $('.select-singlemappage').each(function (htmlSelect) {
      const mapPosition = $(this).data('map-position');
      const mapPage = _this._multiMapPage.getMapAtPosition(mapPosition);
      const options = '#' + $(this).attr('id') + ' option';

      mapPage && $(options).each(function () {
        if ($(this).data('singlemappage-id') === mapPage.id) {
          const selected = '#' + $(htmlSelect).attr('id') + ' option:selected';
          $(selected).removeAttr('selected');
          $(this).prop('selected', true);
        }
      });
    });
  }

  /** @returns { string } */
  _créerHTMLOptionsChoixCarte () {
    let options = '<option class="select-singlemappage__option--default" disabled selected data-text="leftMenu.multiMap.selectMapDefaultOption"></option>';
    this._singleMapPages.forEach(function (singleMapPage) {
      options += '<option data-singlemappage-id="' + singleMapPage.id + '">' + singleMapPage.title + '</option>';
    });
    return options;
  }

  _écouterHTMLSelectChoixCarteChangé () {
    const _this = this;
    $('.select-singlemappage').off('change').on('change', function () {
      const positionCarte = $(this).data('map-position');
      const conteneurCarteOL = '#multimap-' + _this._multiMapPage.id + '__map' + positionCarte + ' > .ol-viewport';
      const optionSélectionnée = '#' + $(this).attr('id') + ' option:selected';
      const idCarteSélectionnée = $(optionSélectionnée).data('singlemappage-id');

      $(conteneurCarteOL).remove();

      const mapPage = _this._singleMapPages.find(mapPage => mapPage.id === idCarteSélectionnée);
      const anciennePosition = _this._multiMapPage.getMapPosition(mapPage);
      const cartePrésenteSurNouvellePosition = _this._multiMapPage.getMapAtPosition(positionCarte);

      if (anciennePosition !== -1 && anciennePosition !== positionCarte) {
        _this._multiMapPage.enleverCarteDePosition(anciennePosition);
        _this._sélectionnerOptionChoixCarteParDéfaut(anciennePosition);
      }

      cartePrésenteSurNouvellePosition && cartePrésenteSurNouvellePosition.resetTarget();
      _this._multiMapPage.setMapAtPosition(mapPage, positionCarte);
    });
  }

  /** @param { number } positionPrécédente */
  _sélectionnerOptionChoixCarteParDéfaut (positionPrécédente) {
    const selectElement = '#select-singlemappage-' + positionPrécédente;
    const selected = selectElement + ' option:selected';
    const defaultOption = selectElement + ' ' + '.select-singlemappage__option--default';
    $(selected).removeAttr('selected');
    $(defaultOption).prop('selected', true);
  }
}
